import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m20.5 11.353 5.156 5.147-5.156 5.147v-2.522c0-.623-.502-1.125-1.125-1.125H13.75v-3h5.625c.623 0 1.125-.502 1.125-1.125zM28 16.5a2.03 2.03 0 0 0-.595-1.434l-5.443-5.429a2.175 2.175 0 0 0-3.712 1.538v1.575h-4.5A2.25 2.25 0 0 0 11.5 15v3a2.25 2.25 0 0 0 2.25 2.25h4.5v1.575a2.177 2.177 0 0 0 3.712 1.538l5.443-5.429c.38-.38.595-.895.595-1.434M11.875 8.25c.623 0 1.125-.502 1.125-1.125S12.498 6 11.875 6h-3.75A4.125 4.125 0 0 0 4 10.125v12.75A4.125 4.125 0 0 0 8.125 27h3.75c.623 0 1.125-.502 1.125-1.125s-.502-1.125-1.125-1.125h-3.75a1.875 1.875 0 0 1-1.875-1.875v-12.75c0-1.036.84-1.875 1.875-1.875z" }, null, -1)
  ]))]))
}
export default { render: render }